import React from 'react';
import {
  FetchRfqPartnersQuery,
  CapaQuotationUserRfqDetail
} from '@generated/graphql';
import { Box, makeStyles, Theme } from '@material-ui/core';
import DrawingFilesPermissionList from './DrawingFilesPermissionList';
import { CustomizedTypography } from '@components/Customized';

const useStyles = makeStyles<Theme>((theme) => {
  return {
    root: {
      width: '100%'
    },
    designRequest: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        marginTop: 136
      }
    }
  };
});

interface Props {
  rfqDetail?: CapaQuotationUserRfqDetail;
  matches?: boolean;
  publicOpen?: boolean;
  rfqPartnersData?: FetchRfqPartnersQuery;
  onAllowRfqDrawingFileDownload: (
    quotationPartnerId: string,
    permission: boolean,
    organizationName: string
  ) => void;
  isDesign?: boolean;
}

const DrawingFilesPermissionPresenter: React.FC<Props> = ({
  rfqDetail,
  matches,
  publicOpen,
  rfqPartnersData,
  onAllowRfqDrawingFileDownload,
  isDesign = false
}) => {
  const classes = useStyles({ matches });
  const dataList = rfqPartnersData?.fetchRfqPartners.data ?? [];

  return (
    <div className={classes.root}>
      {isDesign ? (
        <Box className={classes.designRequest}>
          <CustomizedTypography
            variant={matches ? 'body2' : 'body1'}
            color="textSecondary"
          >
            참고한 이미지 파일이 없습니다.
          </CustomizedTypography>
        </Box>
      ) : (
        <DrawingFilesPermissionList
          rfqDetail={rfqDetail}
          publicOpen={publicOpen}
          dataList={dataList}
          matches={matches}
          onAllowRfqDrawingFileDownload={onAllowRfqDrawingFileDownload}
        />
      )}
    </div>
  );
};

export default DrawingFilesPermissionPresenter;
